import { builder } from '.';
import _ from 'lodash';

export const glassBeneficiaryGetter = builder.read(state => {
    //do la lente al primo giocatore che non ne ha, oppure al tavolo se non ci sono giocatori senza lenti
    return _.find(state.sortedPlayers, p => state.playersGlasses[p.id] == 0);
}, "glassBeneficiary");

export const playerSeeableCardsGetter = builder.read(state => {
    const playerSeeableCards = [...state.secretCards];
    _.forEach(state.playersPublicCards, cards => {
        playerSeeableCards.push(...cards);
    });
    return playerSeeableCards;
}, "playerSeeableCardsGetter");